import { render, staticRenderFns } from "./AdminTabNavigation.vue?vue&type=template&id=00bfd92a&"
import script from "./AdminTabNavigation.vue?vue&type=script&lang=js&"
export * from "./AdminTabNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports